export default function () {

	// https://dev.to/wlarch/custom-youtube-thumbnail-and-play-button-for-embedded-iframe-video-25pb
	//
	/**
	 * Get videos on load
	 */
	( function () {

		getVideos();

	} )();

	/**
	 * For each video player, create custom thumbnail or
	 * use Youtube max resolution default thumbnail and create
	 * iframe video.
	 */
	function getVideos() {

		var v = document.getElementsByClassName( "videoPlayer_player" );
		for ( var n = 0; n < v.length; n++ ) {

			var p = document.createElement( "div" );
			var id = v[n].getAttribute( "data-id" );

			var placeholder;
			if ( v[n].hasAttribute( "data-thumbnail" ) ) {

				if ( window.devicePixelRatio === 1 ) {

					placeholder = v[n].getAttribute( "data-thumbnail" );

				} else {

					placeholder = v[n].getAttribute( "data-thumbnail-2x" );

				}

			} else {

				placeholder = "";

			}

			if ( placeholder.length ) {

				p.innerHTML = createCustomThumbail( placeholder );

			}
			else {

				p.innerHTML = createThumbail( id );

			}

			v[n].appendChild( p );
			p.addEventListener( "click", function () {

				var parent = this.parentNode;
				createIframe( parent, parent.getAttribute( "data-id" ) );

			} );

		}

	}

	/**
	 * Create custom thumbnail from data-attribute provided url
	 * @param {string} url
	 * @return {string} The HTML containing the <img> tag
	 */
	function createCustomThumbail( url ) {

		return (
			`<img class="videoPlayer_thumbnail" src="${
				url
			}" alt="Youtube Preview" /><button class="videoPlayer_play"></button>`
		);

	}

	/**
	 * Get Youtube default max resolution thumbnail
	 * @param {string} id The Youtube video id
	 * @return {string} The HTML containing the <img> tag
	 */
	function createThumbail( id ) {

		return (
			`<img class="videoPlayer_thumbnail" src="//i.ytimg.com/vi_webp/${
				id
			}/maxresdefault.webp" alt="Youtube Preview"><button class="videoPlayer_play"></button>`
		);

	}

	/**
	 * Create and load iframe in Youtube container
	 * @param v
	 * @param id
	 **/
	function createIframe( v, id ) {

		var iframe = document.createElement( "iframe" );
		iframe.setAttribute(
			"src",
			`//www.youtube.com/embed/${
				id
			}?autoplay=1&color=white&autohide=2&modestbranding=1&border=0&wmode=opaque&enablejsapi=1&showinfo=0&rel=0`
		);
		iframe.setAttribute( "frameborder", "0" );
		iframe.setAttribute( "class", "videoPlayer_iframe" );
		v.firstChild.replaceWith( iframe );

	}

}
